import type { Theme } from '../../types/theme';

export const supabaseTheme: Theme = {
  id: 'supabase',
  name: 'Supabase',
  description: 'Dark-mode native developer platform with emerald green accents. Terminal-inspired with near-black backgrounds.',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/supabase/DESIGN.md',
  visualKeywords: ['dark', 'terminal', 'emerald green', 'developer', 'near-black', 'pill buttons'],
  colors: {
    background: '#171717',
    surface: '#0f0f0f',
    surfaceElevated: '#242424',
    surfaceDark: '#0f0f0f',
    textPrimary: '#fafafa',
    textSecondary: '#b4b4b4',
    textMuted: '#898989',
    border: '#2e2e2e',
    borderSubtle: '#363636',
    primary: '#3ecf8e',
    primaryHover: '#00c573',
    primaryActive: '#00a864',
    accent: '#3ecf8e',
    onPrimary: '#0f0f0f',
    success: '#3ecf8e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Circular, -apple-system, BlinkMacSystemFont, sans-serif',
    bodyFont: 'Circular, -apple-system, BlinkMacSystemFont, sans-serif',
    monoFont: '"Source Code Pro", Menlo, monospace',
    headingWeight: '400',
    bodyWeight: '400',
    letterSpacingHeading: '0',
    letterSpacingBody: '0',
  },
  radius: {
    button: '9999px',
    card: '16px',
    panel: '8px',
    badge: '9999px',
    input: '6px',
  },
  shadow: {
    card: 'none',
    elevated: 'none',
    button: '0 0 0 1px #fafafa',
    none: 'none',
  },
  layout: {
    maxWidth: '1200px',
    sectionSpacing: '96px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'medium',
    tone: 'developer-native, open-source, terminal-inspired',
    productFit: ['Backend-as-a-service', 'Database tools', 'Auth platforms', 'Developer APIs'],
    bestFor: ['Developer tools', 'Open-source products', 'Backend platforms', 'API-first products'],
    notGoodFor: ['Consumer apps', 'Healthcare', 'Government', 'Enterprise legacy systems'],
  },
};
